module.exports = __webpack_public_path__ + "img/activity-tracker-logo.eb513aad.webp";